module.exports = __webpack_public_path__ + "static/media/rabbit.06944ca9.svg";